// return string OR throw
type GuaranteedParams = { name: string; value?: string };
// return string OR null OR throw
type OptionalParams = { name: string; value?: string; optional?: boolean };

export function validate({ name, value }: GuaranteedParams): string;
export function validate({ name, value, optional }: OptionalParams): string | null;
export function validate({ name, value, optional }: OptionalParams): string | null {
  if (optional && value == null) {
    console.error(`Missing env ${name}, found value ${value}`);
    return null;
  }

  if (!value) {
    throw new Error(`Missing env ${name}, found value ${value}`);
  }

  return value;
}

export const { NEXT_PUBLIC_BUILDER_API_KEY, NEXT_PUBLIC_REVALIDATION } = {
  NEXT_PUBLIC_BUILDER_API_KEY: validate({
    name: 'NEXT_PUBLIC_BUILDER_API_KEY',
    value: process.env.NEXT_PUBLIC_BUILDER_API_KEY,
  }),
  NEXT_PUBLIC_REVALIDATION: validate({
    name: 'NEXT_PUBLIC_REVALIDATION',
    value: process.env.NEXT_PUBLIC_REVALIDATION,
  }),
};

export const { NEXT_PUBLIC_CALENDLY_URL } = {
  NEXT_PUBLIC_CALENDLY_URL: validate({
    name: 'NEXT_PUBLIC_CALENDLY_URL',
    value: process.env.NEXT_PUBLIC_CALENDLY_URL,
    optional: true,
  }),
};
